exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".announcementSnackbar-iconButton{color:inherit;justify-content:flex-start;margin-bottom:16px}.announcementSnackbar-root{background-color:#edc9c9;color:var(--error-text-color);width:100%;flex-wrap:nowrap}.announcementSnackbar-warningIcon{margin-right:12px}.announcementSnackbar-messageContainer{display:flex;justify-content:space-between}.announcementSnackbar-messageText{color:var(--error-text-color);font-size:16px;padding-top:4px}\n", ""]);

// exports
